import Insurance, {IInsurance} from "@/model/Insurance/Insurance"
import hasQuoteTravellers, { IHasQuoteTravellers } from "@/model/mixins/hasQuoteTravellers"
import hasTravellersEligible, {IHasTravellersEligible} from "@/model/mixins/Traveller/hasTravellersEligible"
import hasTravellersSelected, {IHasTravellersSelected} from "@/model/mixins/Traveller/hasTravellersSelected"
import hasTravellersIncluded, {IHasTravellersIncluded} from "@/model/mixins/Traveller/hasTravellersIncluded"
import hasIncluded, {IHasIncluded} from "@/model/mixins/hasIncluded"
import hasTotalPriceByTravellerOrAccomodationId, {IHasTotalPriceByTravellerOrAccomodationId} from "@/model/mixins/Price/hasTotalPriceByTravellerOrAccomodationId"

class ParticipantInsuranceBase extends Insurance {

    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
    }

    getSelectedQuantity(): number {
        return Number(this.getQuantity())
    }

}

export interface IParticipantInsurance extends ParticipantInsuranceBase, IHasTotalPriceByTravellerOrAccomodationId, IHasIncluded, IHasTravellersIncluded, IInsurance, IHasQuoteTravellers, IHasTravellersEligible, IHasTravellersSelected {}

// apply mixins
const ParticipantInsurance: Constructor<IParticipantInsurance> = hasTotalPriceByTravellerOrAccomodationId(hasIncluded(hasTravellersIncluded(hasTravellersSelected(hasTravellersEligible(hasQuoteTravellers(ParticipantInsuranceBase))))))

export default ParticipantInsurance